// Homepage for SugarDB database, contains search and filter options, and displays data in card or table view

import { useState, useEffect } from 'react';
import { Icon, Button, Header, Checkbox, Accordion } from 'semantic-ui-react';
import axios from "axios"

import "../pages/css/databasehome.css";

// helper functions
import databaseUtils from '../components/databaseUtils';

//componenets:
import AdvancedSearchBar from '../components/database/AdvancedSearchBar';
import FilterBar from '../components/database/FilterBar';
import CardView from '../components/database/CardView';
import TableView from '../components/database/TableView';

export default function DatabaseHome() {
    //const hostingServer = `https://sugardb.cs.uct.ac.za/`;
    //fix so works locally
    const hostingServer =
    process.env.NODE_ENV === 'development'
    ? 'http://localhost:8888/'
    : 'https://sugardb.cs.uct.ac.za/';
   
    //views
    const [viewMode, setViewMode] = useState(localStorage.getItem('view') || 'card'); // Initialize with the value from localStorage
    const [helpClicked, setHelpClicked] = useState(false)

    //data
    const [allData, setAllData] = useState([]) //initialize wiht empty array
    const [activeSpeciesData, setactiveSpeciesData] = useState([allData])
    const [searchData, setSearchData] = useState([allData]); // search data default - this is the search applied to the active species
    const [filteredSearchData, setFilteredSearchData] = useState([searchData]); // search data default - this is the search applied to the active species

    const [maxRepeatUnit, setMaxRepeatUnit] = useState(0)
    const [antigenTypes, setAntigenTypes] = useState([])
    const [speciesCounts, setSpeciesCounts] = useState(null)
    
    //toggle data
    const [inactiveSpecies, setInactiveSpecies] = useState({});
    const [speciesPanelActiveIndex, setSpeciesPanelActiveIndex] = useState(0);
    const isTable = viewMode === 'table';
    const isCard  = viewMode === 'card';


    //query components
    const [openFilter, setOpenFilter] = useState(false) // [state, setState]
    const [search, setSearch] = useState('')
    const [filterResponse, setFilterResponse] = useState('') // message for filter response
    const [clearFlag, setClearFlag] = useState(false) // [state, setState]
  
    //info card modal
    const [selectedEntry, setSelectedEntry] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    // initial fetch data and set view
    useEffect( () => {
        let processing = true
        axiosFetchData(processing)

        return () => {
            console.log('local view is: ', localStorage.getItem('view'))
            processing = false
        }
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, []) // empty array means only run once

    /* useEffect(() => { // MK testing 
        console.log('testing')
       axios.get('http://localhost:8888/api/hello')
      .then(response => {
        setTestData(response.data); // response.data is the actual data from the server
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);
 */

useEffect(() => {
    if (allData && allData.length) {
            const speciesMap = {};
            allData.forEach(item => {
                const species = item.Species_where_found;
                speciesMap[species] = true;
            });
            setInactiveSpecies(speciesMap);
            setSearchData(allData); // show everything by default
            setSearch('');   // clear the search bar
            setFilteredSearchData(allData);
           
            //need to reset filters - how?

            
    }
}, [allData]); //run every time allData changes, which should not be often/ever

useEffect(() => {
   // Re-filter based on updated species
   // FIX: Only run when inactiveSpecies changes, NOT when searchData changes
   // This prevents infinite loop when search updates data
    const sieved = allData.filter(item => inactiveSpecies[item.Species_where_found]);
    const searched= searchData.filter(item => inactiveSpecies[item.Species_where_found]);
    const filtered=filteredSearchData.filter(item => inactiveSpecies[item.Species_where_found]);

    // Update all three states
    setactiveSpeciesData(sieved);
    setSearchData(searched);
    setFilteredSearchData(filtered);
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [inactiveSpecies]); // ONLY depends on inactiveSpecies to prevent loop


const toggleSpecies = (species) => {
  setInactiveSpecies(prev => {
    const updated = {
      ...prev,
      [species]: !prev[species]
    };
    return updated;
  });
};

// for button
const selectAllSpecies = () => {
    const updated = {};
    Object.keys(inactiveSpecies).forEach(species => {
        updated[species] = true;
    });
    setInactiveSpecies(updated);
};

const clearAllSpecies = () => {
    const updated = {};
    Object.keys(inactiveSpecies).forEach(species => {
        updated[species] = false;
    });
    setInactiveSpecies(updated);
};

    // get all antigen types from data
    const getAntigenTypes = (data) => {
        let types = []
        data.forEach(item => {
            if (!types.includes(item.Antigen_type)) {
                types.push(item.Antigen_type)
            }
        })
        setAntigenTypes(types)
        console.log('antigen types: ', antigenTypes)
    }

    // fetch data from backend, set initial data and max repeat unit for filter
    const axiosFetchData = async (processing) => { // you dont need to convert to JSON using axios
        // get from hosting server
        //console.log(hostingServer)
        await axios.get(`${hostingServer}api/carb_structures`)
        //http://localhost:8888/
        //await axios.get(`http://localhost:8888/api/carb_structures`)
        .then(response => {
            if (processing) { 
                setAllData(response.data) 
                setSearchData(response.data) // initialise filtered data
                setMaxRepeatUnit(Math.max(...response.data.map(item => item.Repeat_unit_size)))
                getAntigenTypes(response.data)
                // console.log('species counts: ', countOccurances(response.data, 'Species_where_found'))
                const counts = databaseUtils.countOccurrences(response.data, 'Species_where_found');
                setSpeciesCounts(counts)
                // countSpecies(response.data)
            }
        })
        .catch(error => console.log(error))
    }

    // handle entry click to open modal
    const handleEntryClick = (entry) => {
        setSelectedEntry(entry);
        setModalOpen(true);
        // console.log(entry);
    }

    // close modal and reset selected entry
    const handleInfoCardModalClose = () => {
        setModalOpen(false);
        setSelectedEntry(null);
    }

    // toggle filter bar and close help
    const toggleFilterOptions = () => {
        setOpenFilter(!openFilter)
        setHelpClicked(false)
    } 

    // toggle view mode between card and table
    const handleViewToggle = (mode) => {
        setViewMode(mode);
        localStorage.setItem('view', mode);
        
    };
    
    // filter data based on search input
    const handleSearchData = (data) => {
        setSearchData(data);
        // FIX: Also update filteredSearchData so results display immediately
        // FilterBar will re-filter if filters are active
        setFilteredSearchData(data);
    }

    const handleFilterData = (data) => {
        setFilteredSearchData(data)
    }

    // toggle help bubbles to annotate page, close filter bar
    const handleHelpClick = () => {
        setHelpClicked(!helpClicked)
        setOpenFilter(false)
    }
    //<h3><p>{hostingServer}</p></h3> // for testing
    // <p>There are {testData } items.</p> for testing


    return (
       <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',         // ⭐️ CHANGED: fill viewport height
        overflow: 'hidden',      // ⭐️ CHANGED: prevent double scrollbars
        padding: '1rem'
      }}
    >      
          {/* ⭐️ CHANGED: Top Bar stacks vertically on mobile */}
      <div style={{
        display: 'flex',
        flexDirection: 'column', // ⭐️ CHANGED: stack search & filters
        gap: '1rem',
        marginBottom: '1rem'
      }}> 

        <Accordion fluid styled>
          <Accordion.Title
            active={speciesPanelActiveIndex === 0}
            index={0}
            onClick={() =>
              setSpeciesPanelActiveIndex(speciesPanelActiveIndex === 0 ? -1 : 0)
            }
            style={{
              backgroundColor: '#393E46',
              color: 'white',
              padding: '1rem',
              borderRadius: '0.5vh'
            }}
          >
            <Header inverted as='h4' style={{ margin: 0 }}>
              {speciesCounts ? "SugarDB contents" : <Icon name='database' />}
              <Icon name={speciesPanelActiveIndex === 0 ? 'angle up' : 'angle down'} style={{ float: 'right' }} />
            </Header>
          </Accordion.Title>

          <Accordion.Content active={speciesPanelActiveIndex === 0}>
            <ul style={{ color: 'white', textAlign: 'left' }}>
              {speciesCounts ? Object.keys(speciesCounts).map((species, index) => (
                <li key={species}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '1em',
                    color: databaseUtils.colourMap(species)
                  }}>
                  <Checkbox
                    toggle
                    checked={!!inactiveSpecies[species]}
                    onChange={() => toggleSpecies(species, allData)}
                    setSearch={setSearch}
                  />
                  <div className="ui tag label"
                    style={{
                      backgroundColor: databaseUtils.colourMap(species),
                      color: 'black',
                      minWidth: '18em'
                    }}>
                    <em>{species}</em>: {speciesCounts[species]}
                  </div>
                  <div
                    style={{
                      display: 'inline-block',
                      maxWidth: '50em',
                      whiteSpace: 'normal',
                      wordWrap: 'break-word'
                    }}>
                    {'*'.repeat(speciesCounts[species] ?? 0)}
                  </div>
                </li>
              )) : "Carb structure data will load when server is running"}
            </ul>

            <div style={{ marginTop: '1em' }}>
              <button onClick={selectAllSpecies}>Show All</button>
              <button onClick={clearAllSpecies} style={{ marginLeft: '1em' }}>Hide All</button>
            </div>
          </Accordion.Content>
        </Accordion>
      </div>     
      {/* Search and Filter Controls Bar */}
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        marginBottom: "1rem",
        flexWrap: "wrap"
      }}>
        {/* View Toggle and Help */}
        <div className='bubble-container' style={{ alignItems:'center'}}>
          { helpClicked ?
            <div className = "bubble-box-left">
              <p>Toggle between card view and table view</p>
            </div>
          : null }

          <Button.Group>
            <Button
              icon
              toggle
              active={isTable}
              basic={!isTable}
              onClick={() => handleViewToggle('table')}
              aria-label="Table view"
            >
              <Icon name="table" />
            </Button>

            <Button
              icon
              toggle
              active={isCard}
              basic={!isCard}
              onClick={() => handleViewToggle('card')}
              aria-label="Card view"
            >
              <Icon name="th" />
            </Button>
          </Button.Group>

          <Icon
            onClick={handleHelpClick}
            name={ helpClicked ? "times" : "help circle"}
            color={ helpClicked ? 'blue' : "black" }
            size="large"
            style={{cursor:"pointer", marginLeft:'0.5rem'}}
          />
        </div>

        {/* Search Bar - takes remaining space */}
        <div style={{ flex: 1, minWidth: '300px', display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <AdvancedSearchBar
            origData={activeSpeciesData}
            onFilterData={handleSearchData}
            setFilterResponse={setFilterResponse}
            setSearch={setSearch}
            search={search}
            setOpenFilter={setOpenFilter}
            setHelpClicked={setHelpClicked}
            setClearFlag={setClearFlag}
            helpClicked={helpClicked}
          />
        </div>

        {/* Filter Button with Help Bubble */}
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          {helpClicked && (
            <div className="bubble-box-under">
              <p>Filter results by antigen type, residue count, branching, and repeat units</p>
            </div>
          )}
          <FilterBar
            data={searchData}
            onFilterData={handleFilterData}
            setFilterResponse={setFilterResponse}
            setSearch={setSearch}
            openFilter={openFilter}
            toggleFilterOptions={toggleFilterOptions}
            maxRepeatUnit={maxRepeatUnit}
            antigenTypes={antigenTypes}
            clearFlag={clearFlag}
            setClearFlag={setClearFlag}
          />
        </div>
      </div>
                  {filterResponse === '' ? <h4 style={{marginTop:'0', marginBottom:'1rem'}} >
                Special characters: use <strong>\a for α, \b for β, -{'>'} for → </strong>  </h4> : <h4 style={{marginTop:'0', marginBottom:'1rem'}}>{filterResponse}</h4>}

            {/* ⭐️ CHANGED: Main Content Area resizes and scrolls */}
      <div
        style={{
          flex: '1 1 auto',      // ⭐️ CHANGED: allow resizing with window
          overflowY: 'auto',     // ⭐️ CHANGED: scroll content if too tall
          minHeight: 0           // ⭐️ CHANGED: prevents shrinking issues
        }}
      >
            { 
            viewMode === 'table' ?  (
                                <div style={{
                                    overflowX: 'auto'   // ⭐️ CHANGED: TableView scrolls horizontally on mobile
                                }}>
                                    <TableView 
                                            data={ filteredSearchData} 
                                            handleEntryClick={handleEntryClick} 
                                            selectedEntry={selectedEntry} modalOpen={modalOpen} 
                                             handleModalClose={handleInfoCardModalClose}/>
                                        </div>
                                    )     
                                             : (
                                    <div
                                        style={{
                                        display: 'grid',                        // ⭐️ CHANGED: CardView grid layout
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', // ⭐️ Responsive columns
                                        gap: '1rem'
                                        }}
                                    >
                                    <CardView 
                                            data={ filteredSearchData} 
                                            handleEntryClick={handleEntryClick} 
                                            selectedEntry={selectedEntry} 
                                            modalOpen={modalOpen} 
                                            handleModalClose={handleInfoCardModalClose}/>
                                             </div>
                                    )}
            
            </div>   
        </div>
            
        
    )
}